import bundledI18n from '#i18n';
import { createI18nStore, createWireI18n } from '@oneappexchange/lwc-wired';
import { DEFAULT_LANGUAGE, IS_DEVELOPMENT } from '../../config';
import { DEFAULT_LANGUAGE_CODE, JAPANESE_LANGUAGE_CODE } from '../utilities/language';
export const i18nStore = createI18nStore({
  bundledI18n,
  defaultLanguage: DEFAULT_LANGUAGE,
  missingTextSymbol: IS_DEVELOPMENT ? undefined : '',
  i18nModuleLoaders: {
    // Add additional languages here
    [DEFAULT_LANGUAGE_CODE]: () => import('../../i18n/__generated__/i18n.en.json'),
    [JAPANESE_LANGUAGE_CODE]: () => import('../../i18n/__generated__/i18n.ja.json')
  },
  developmentMode: IS_DEVELOPMENT
});
export const WireI18n = createWireI18n(i18nStore);
export function selectCurrentLanguage(state) {
  return state.currentLanguage;
}
export function selectShared(i18n) {
  return i18n.shared;
}
export function selectGlobalHeader(i18n) {
  return i18n.globalHeader;
}
export function selectListingStep(i18n) {
  return i18n.listingStep;
}
export function selectEditorHeader(i18n) {
  return i18n.editorHeader;
}
export function selectListingSetUpStep(i18n) {
  return i18n.listingSetUpStep;
}
export function selectListingDetailStep(i18n) {
  return i18n.listingDetailsStep;
}
export function selectListingMediaStep(i18n) {
  return i18n.listingMediaStep;
}
export function getCharactersRemainingText(remainingCharacters) {
  const {
    i18n
  } = i18nStore.getState();
  return i18n.pfC360Input.charactersRemainingLabel({
    NUMBER: remainingCharacters
  });
}
export function selectListingLinkSolutionStep(i18n) {
  return i18n.listingLinkSolutionStep;
}
export function selectListingBetterSolutionStep(i18n) {
  return i18n.listingBetterBusinessStep;
}
export function selectFooter(i18n) {
  return i18n.footer;
}
export function selectListingEditor(i18n) {
  return i18n.listingEditor;
}
export function selectPublishStatusStep(i18n) {
  return i18n.publishStatusStep;
}
export function selectPublishReady(i18n) {
  return i18n.listingPublishReady;
}